import { useSuspenseQuery } from '@tanstack/react-query';
import type React from 'react';

import {
    type ComputedContentSource,
    checkIsComputedIntegrationSourceType,
    type Integration,
    parseComputedIntegrationSourceType,
} from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

import { apiQuery } from '../../state';

/**
 * Display the title of a computed content source.
 */
export function ComputedSourceTitle(props: {
    source: ComputedContentSource;
    children: (props: { title: string }) => React.ReactNode;
}) {
    const { source, children } = props;
    if (checkIsComputedIntegrationSourceType(source.type)) {
        const sourceType = parseComputedIntegrationSourceType(source.type);
        return (
            <GetIntegration integrationName={sourceType.integration}>
                {(integration) => children({ title: integration.title })}
            </GetIntegration>
        );
    }

    switch (source.type) {
        case 'builtin:openapi':
            return children({ title: 'OpenAPI' });
        case 'builtin:translation': {
            return children({ title: 'Translation' });
        }
        default:
            assertNever(source.type);
    }
}

function GetIntegration(props: {
    integrationName: string;
    children: (integration: Integration) => React.ReactNode;
}) {
    const { integrationName, children } = props;
    const { data: integration } = useSuspenseQuery(
        apiQuery('getIntegrationByName', {
            integrationName,
        })
    );

    return children(integration);
}
